// API Endpoints for Tags management
import { rivermeadowApi } from './api';

export const tags = rivermeadowApi.injectEndpoints({
    endpoints: (builder) => ({
        getTags: builder.query({
            query: ({ orgId, filter }) => ({
                url: `/organizations/${orgId}/tags`,
                method: 'GET',
                params: filter ? { filter } : undefined,
            }),
            providesTags: ['TAGS'],
        }),
        createOrEnsureTag: builder.mutation({
            query: ({ orgId, tag }) => ({
                url: `/organizations/${orgId}/tags`,
                method: 'POST',
                params: { filter: tag },
            }),
            invalidatesTags: ['TAGS'],
        }),
        createOrEnsureTags: builder.mutation({
            query: ({ orgId, tags }) => ({
                url: `/organizations/${orgId}/tags`,
                method: 'POST',
                body: { tags },
            }),
            invalidatesTags: ['TAGS'],
        }),
    }),
});

export const { useLazyGetTagsQuery, useCreateOrEnsureTagMutation, useCreateOrEnsureTagsMutation } = tags;
